import * as React from 'react';
import { SVGProps } from 'react';

const SvgScoreStrategic = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <rect width={16} height={16} rx={2} fill="#A0D4D3" />
    <path d="m8 6 3 2v2L8 8l-3 2V8l3-2Z" fill="#174174" />
  </svg>
);

export default SvgScoreStrategic;
